export default __webpack_public_path__ + "static/media/tipi.3615b2b5.jpg";